export default "__VITE_ASSET__CgWythwd__"